/* Qamar: the launching-soon night. One full-screen WebGL pass: the sky, tonight's moon (its real phase,
   calculated from the date), clouds drifting across it and a fine silver dust. Opens from black. */
(function () {
  'use strict';
  var canvas = document.querySelector('[data-qamar-moon]');
  if (!canvas) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  /* ---------- the phase of the moon right now ---------- */
  var SYNODIC = 29.530588853, NEW_MOON = Date.UTC(2000, 0, 6, 18, 14) / 1000;
  function moonNow() {
    var age = ((Date.now() / 1000 - NEW_MOON) / 86400) % SYNODIC; if (age < 0) age += SYNODIC;
    var theta = 2 * Math.PI * age / SYNODIC;
    var names = ['New moon', 'Waxing crescent', 'First quarter', 'Waxing gibbous', 'Full moon', 'Waning gibbous', 'Last quarter', 'Waning crescent'];
    return { theta: theta, illum: (1 - Math.cos(theta)) / 2, name: names[Math.floor((age / SYNODIC) * 8 + .5) % 8] };
  }
  var label = document.querySelector('[data-qamar-moon-label]');
  function writeLabel() {
    var m = moonNow();
    if (label) label.textContent = m.name + ' · tonight';
    canvas.setAttribute('aria-label', 'Tonight’s moon: ' + m.name.toLowerCase() + ', ' + Math.round(m.illum * 100) + ' percent illuminated');
  }
  writeLabel(); setInterval(writeLabel, 60000);

  function start() { body.classList.add('qs-go'); }
  var gl = canvas.getContext('webgl', { antialias: false, alpha: false });
  if (!gl) { canvas.classList.add('is-fallback'); start(); return; }

  var FRAG = [
    'precision highp float;',
    'uniform vec2 uRes; uniform float uTime; uniform float uTheta; uniform sampler2D uTex; uniform float uTexOn;',
    'uniform vec2 uMoon; uniform float uR; uniform float uLib; uniform float uOpen; uniform vec2 uPar; uniform vec4 uShoot; uniform float uShootT;',
    'float h(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),u.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),u.x),u.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}',
    'void main(){',
    ' vec2 fc=gl_FragCoord.xy; vec2 uv=fc/uRes; float md=max(uRes.x,uRes.y);',
    ' vec2 mc=uMoon+uPar; vec2 p=(fc-mc)/uR; float r=length(p); float e=1.5/uR;',
    ' float lit=(1.-cos(uTheta))*.5;',
    // the night: deep emerald, a little lighter around the moon
    ' vec3 deep=vec3(.008,.045,.041), em=vec3(.040,.180,.164), ink=vec3(.003,.016,.014);',
    ' float dm=distance(fc,mc)/md;',
    ' vec3 col=mix(em,deep,smoothstep(0.,.75,dm)); col=mix(col,ink,smoothstep(.45,1.15,length((uv-.5)*vec2(1.,1.2))));',
    // light from the lit limb
    ' vec3 L=normalize(vec3(sin(uTheta),.05,-cos(uTheta)));',
    ' vec2 Ld=normalize(L.xy+vec2(1e-4,0.)); float side=mix(1.,.15+.85*pow(max(dot(p/max(r,1e-3),Ld),0.),1.4),1.-lit);',
    ' float o=max(r-1.,0.); float breath=.9+.1*sin(uTime*.45);',
    ' col+=vec3(.86,.88,.84)*(.16*exp(-o*4.5)+.08*exp(-o*1.3)+.03*exp(-o*.4))*(.25+.75*lit)*side*breath*smoothstep(.97,1.03,r);',
    // the moon
    ' if(r<1.+e){',
    '  float z=sqrt(max(1.-r*r,0.)); vec3 N=vec3(p,z);',
    '  float lon=atan(N.x,N.z)+uLib; float lat=asin(clamp(N.y,-1.,1.));',
    '  vec3 alb=vec3(.86,.85,.82);',
    '  if(uTexOn>.5){float lum=texture2D(uTex,vec2(.5+lon/6.28318,.5-lat/3.14159)).r; lum=clamp((lum-.16)/.64,0.,1.); alb=vec3(1.,.985,.955)*(.36+.68*pow(lum,.85));}',
    '  float d=dot(N,L); float diff=smoothstep(-.02,.09,d)*pow(clamp(d,0.,1.),.45);',
    '  vec3 m=alb*diff*1.2*mix(.88,1.,pow(z,.35)); m=1.-exp(-m*1.8); m*=1.08;',
    '  float mask=smoothstep(1.,1.-e,r);',
    '  col=mix(col,m,mask*smoothstep(0.,.12,diff))+alb*.018*mask*(1.-smoothstep(0.,.12,diff));',
    ' }',
    // the stars: round points of light, twinkling, never in front of the moon
    ' float behind=smoothstep(1.,1.08,r); float nearMoon=smoothstep(1.1,2.6,r);',
    ' for(int i=0;i<3;i++){',
    '  float s=float(i); vec2 g=(fc+uPar*(.3+s*.3))/md*(90.+s*70.); vec2 id=floor(g); vec2 f=fract(g)-.5;',
    '  float rnd=h(id+s*17.3); vec2 off=(vec2(h(id+1.7),h(id+9.1))-.5)*.4; float dd=length(f-off);',
    '  float big=step(.96,h(id+4.4)); float sz=(.10+.07*h(id+5.5)+.05*big)*(1.-s*.2); float tw=.6+.4*sin(uTime*(.8+2.*h(id+2.2))+rnd*60.);',
    '  float on=step(.80+s*.04,rnd);',
    '  float core=smoothstep(sz,0.,dd); float halo=exp(-dd*dd/(sz*sz*2.2))*smoothstep(.28,.08,dd)*.4*big;',
    '  col+=vec3(.93,.95,.93)*(core+halo)*on*tw*(.95-s*.24)*behind*(.45+.55*nearMoon);',
    ' }',
    // a shooting star now and then
    ' if(uShootT>=0.){',
    '  vec2 hd=uShoot.xy+uShoot.zw*uShootT; vec2 dir=normalize(uShoot.zw); float len=length(uShoot.zw)*.55;',
    '  vec2 v=fc-hd; float along=-dot(v,dir); float across=abs(v.x*dir.y-v.y*dir.x);',
    '  float tail=step(0.,along)*(1.-smoothstep(0.,len,along)); float head=exp(-dot(v,v)/(6.*uR*.002+4.));',
    '  float w=(1.4+2.2*(1.-clamp(along/len,0.,1.)))*uRes.y/1000.; float fade=sin(3.14159*clamp(uShootT,0.,1.));',
    '  col+=vec3(.96,.97,.94)*fade*behind*(tail*exp(-across*across/(w*w))*1.35+head*1.8);',
    ' }',
    // clouds drifting slowly across the sky and the face of the moon, lit where the moon is behind them
    ' vec2 q=vec2(fc.x/md,fc.y/md);',
    ' float t=uTime;',
    ' float c1=fbm(q*vec2(2.2,5.5)+vec2(t*.010,t*.002));',
    ' float c2=fbm(q*vec2(4.,9.)+vec2(-t*.016,4.)+c1*1.2);',
    ' float dens=smoothstep(.40,.80,c1*.62+c2*.48);',
    ' float band=exp(-pow((fc.y-mc.y)/(uR*1.8),2.));',
    ' dens*=.35+.65*band;',
    ' float mlight=exp(-max(r-.2,0.)*1.1)*(.25+.75*lit);',
    ' vec3 cloud=mix(vec3(.02,.075,.068),vec3(.62,.66,.63),clamp(mlight,0.,1.));',
    ' col=mix(col,cloud,dens*.58);',
    // fine silver dust rising
    ' for(int i=0;i<2;i++){',
    '  float s=float(i);',
    '  vec2 g=fc/md*vec2(26.+s*14.)+vec2(s*7.3,-t*(.05+s*.03)*8.);',
    '  vec2 id=floor(g); vec2 f=fract(g)-.5; float rnd=h(id+s*13.1);',
    '  vec2 off=vec2(h(id+3.1),h(id+7.7))-.5; float dd=length(f-off*.7);',
    '  float tw=.5+.5*sin(t*(.6+rnd)+rnd*40.);',
    '  col+=vec3(.85,.87,.84)*smoothstep(.06,.0,dd)*step(.88,rnd)*tw*(.26-s*.08);',
    ' }',
    // opening from black
    ' col*=smoothstep(0.,1.,uOpen);',
    ' col+=(h(fc*.73+fract(uTime*.37)*91.)-.5)*.02;',
    ' gl_FragColor=vec4(col,1.);',
    '}'
  ].join('\n');
  function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(o)); return o; }
  var prog;
  try {
    prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}'));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FRAG)); gl.linkProgram(prog); gl.useProgram(prog);
  } catch (e) { canvas.classList.add('is-fallback'); start(); return; }
  var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var U = {}; ['uRes', 'uTime', 'uTheta', 'uTex', 'uTexOn', 'uMoon', 'uR', 'uLib', 'uOpen', 'uPar', 'uShoot', 'uShootT'].forEach(function (k) { U[k] = gl.getUniformLocation(prog, k); });
  var texOn = 0, t0 = null, img = new Image(); img.crossOrigin = 'anonymous';
  img.onload = function () {
    var t = gl.createTexture(); gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, t);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img); gl.generateMipmap(gl.TEXTURE_2D);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    texOn = 1; begin();
  };
  img.onerror = begin;
  img.src = canvas.getAttribute('data-map');
  setTimeout(begin, 2500);                      // never wait long for the map
  function begin() { if (t0 === null) { t0 = performance.now(); start(); } }
  gl.uniform1i(U.uTex, 0);

  var dpr = 1, W = 0, H = 0, anchor = document.querySelector('[data-qs-moon-anchor]');
  function size() {
    dpr = Math.min(window.devicePixelRatio || 1, innerWidth < 760 ? 1.5 : 2);
    W = innerWidth; H = innerHeight;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    gl.viewport(0, 0, canvas.width, canvas.height);
  }
  size(); addEventListener('resize', size);
  // the moon follows the pointer, or the tilt of the phone, by a few pixels
  var px = 0, py = 0, tx = 0, ty = 0;
  addEventListener('pointermove', function (e) { tx = (e.clientX / W - .5) * 2; ty = (e.clientY / H - .5) * 2; }, { passive: true });
  addEventListener('deviceorientation', function (e) { if (e.gamma == null) return; tx = Math.max(-1, Math.min(1, e.gamma / 25)); ty = Math.max(-1, Math.min(1, (e.beta - 45) / 25)); }, { passive: true });

  // shooting stars: one every few seconds, high in the sky, crossing on a shallow diagonal
  var shoot = null, nextShoot = performance.now() + 3200;
  function launch(now) {
    var fromLeft = Math.random() < .5, x0 = W * (fromLeft ? .08 + Math.random() * .35 : .57 + Math.random() * .35), y0 = H * (.06 + Math.random() * .22);
    var dx = (fromLeft ? 1 : -1) * W * (.22 + Math.random() * .14), dy = H * (.12 + Math.random() * .1);
    shoot = { x0: x0, y0: y0, dx: dx, dy: dy, start: now, dur: 900 + Math.random() * 500 };
    nextShoot = now + 2600 + Math.random() * 3800;
  }
  var clock = performance.now();
  (function frame(now) {
    var t = (now - clock) / 1000, m = moonNow();
    var open = t0 === null ? 0 : Math.min(1, (now - t0) / (reduce ? 400 : 3600));
    var ease = 1 - Math.pow(1 - open, 3);
    if (!reduce) { px += (tx - px) * .03; py += (ty - py) * .03; }
    // where the moon sits: the centre of the anchor element in the layout
    var cx = W / 2, cy = H * .42, rad = Math.min(W, H) * (W < 760 ? .30 : .2);
    if (anchor) { var a = anchor.getBoundingClientRect(); cx = a.left + a.width / 2; cy = a.top + a.height / 2; rad = a.width / 2; }
    var grow = reduce ? 1 : .94 + .06 * ease;
    gl.uniform2f(U.uRes, canvas.width, canvas.height);
    gl.uniform1f(U.uTime, t);
    gl.uniform1f(U.uTheta, m.theta);
    gl.uniform2f(U.uMoon, cx * dpr, (H - cy) * dpr);
    gl.uniform1f(U.uR, rad * grow * dpr);
    gl.uniform2f(U.uPar, px * -10 * dpr, py * 8 * dpr);
    gl.uniform1f(U.uLib, reduce ? 0 : Math.sin(t * .05) * .06);
    gl.uniform1f(U.uOpen, ease);
    gl.uniform1f(U.uTexOn, texOn);
    if (!reduce && t0 !== null && open >= 1 && now > nextShoot && !shoot) launch(now);
    var st = -1;
    if (shoot) { st = (now - shoot.start) / shoot.dur; if (st > 1) { shoot = null; st = -1; } }
    if (shoot) gl.uniform4f(U.uShoot, shoot.x0 * dpr, (H - shoot.y0) * dpr, shoot.dx * dpr, -shoot.dy * dpr);
    gl.uniform1f(U.uShootT, st);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    requestAnimationFrame(frame);
  })(clock);
})();
